import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
type Props = {
    dates: Date[];
    selected?: Date;
    onSelectDate: (date: Date) => void;
};
const Calendar = ({ dates, selected, onSelectDate }: Props) => {
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [days, setDays] = useState<number[]>([]);
    const [firstDay, setFirstDay] = useState<number | undefined>();
    const [lastDay, setLastDay] = useState<number>(0);
    useEffect(() => {
        updateCalendar();
    }, [currentMonth, currentYear]);
    const updateCalendar = () => {
        const daysArray: number[] = [];
        const date = new Date(currentYear, currentMonth, 1);
        setFirstDay(date.getDay());
        const lastDate = new Date(currentYear, currentMonth + 1, 0);
        setLastDay(lastDate.getDay());
        const numDays = lastDate.getDate();
        for (let i = 1; i <= numDays; i++) {
            daysArray.push(i);
        }
        setDays(daysArray);
    };
    const prevMonth = () => {
        if (currentMonth === 0) {
            setCurrentMonth(11);
            setCurrentYear(currentYear - 1);
        } else {
            setCurrentMonth(currentMonth - 1);
        }
    };
    const nextMonth = () => {
        if (currentMonth === 11) {
            setCurrentMonth(0);
            setCurrentYear(currentYear + 1);
        } else {
            setCurrentMonth(currentMonth + 1);
        }
    };
    const isMarked = (day: number) => {
        for (const date of dates) {
            if (
                date.getFullYear() === currentYear &&
                date.getMonth() === currentMonth &&
                date.getDate() + 1 === day
            ) {
                return true;
            }
        }
        return false;
    };
    const isSelected = (day: number) => {
        return (
            selected &&
            selected.getFullYear() === currentYear &&
            selected.getMonth() === currentMonth &&
            selected.getDate() === day
        );
    };
    const onClickDate = async (day: number) => {
        onSelectDate(await new Date(currentYear, currentMonth, day));
    };
    const monthNames = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ];
    const firstDayArray = Array(firstDay || 0).fill(null);
    const lastDayArray = Array(6 - lastDay).fill(null);
    return (
        <Box className="calendar-container">
            <Paper elevation={3}>
                <Box className="calendar-header">
                    <Button variant="outlined" onClick={prevMonth}>
                        &lt;
                    </Button>
                    <Typography variant="h6">
                        {monthNames[currentMonth]} {currentYear}
                    </Typography>
                    <Button variant="outlined" onClick={nextMonth}>
                        &gt;
                    </Button>
                </Box>

                <Box className="calendar-weekdays">
                    {['D', 'L', 'M', 'X', 'J', 'V', 'S'].map((d, index) => (
                        <Box key={index}>{d}</Box>
                    ))}
                </Box>

                <Grid container spacing={1} className="calendar">
                    {firstDayArray.map((_, i) => (
                        <Grid item key={i} />
                    ))}
                    {days.map((day) => (
                        <Grid
                            item
                            key={day}
                            className={`${
                                isMarked(day) ? 'calendar-marked' : ''
                            } ${isSelected(day) ? 'calendar-selected' : ''}`}
                            onClick={() => isMarked(day) && onClickDate(day)}
                        >
                            {day}
                        </Grid>
                    ))}
                    {lastDayArray.map((_, i) => (
                        <Grid item key={i} />
                    ))}
                </Grid>
            </Paper>
        </Box>
    );
};

export default Calendar;
